<template>
  <div class="course-detail-box">
    <div v-if="subject" class="subject-box">
      <video-player v-if="subjectItem.id" :src="subjectItem" @play="playVideo" :isHack="hack" />
      <div class="user-info">
        <div class="user-avatar">
          <img v-if="userInfo && userInfo.avatar" :src="userInfo.avatar" />
          <img v-else :src="require('@/assets/icons/none.png')" />
        </div>
        <!-- <div class="user-score">
          <img src="@/assets/icons/star.png" />
          <span>20</span>
        </div> -->
        <div class="subject-info">
          <span class="title">{{ subject.title }}</span> | <span class="chapter">{{ subjectItem.title }}</span>
        </div>
      </div>
      <van-tabs v-model="active" color="#ff7a22" title-active-color="#ff7a22" title-inactive-color="#999">
        <van-tab title="简介与问答">
          <div class="afterClass">
            <div class="clip_img_box">
              <img src="@/assets/icons/clip_img.png" alt="">
            </div>
            <template v-if="subject.canVote">
              <div class="after_class_title">
                <span class="after_class_text">已有 <b>{{subjectItem.vote}}</b> 人点赞</span>
                <span class="cylinder_border"></span>
              </div>
              <div class="vote">
                <div class="submit_answer_btn"  @click="voteSubjectItem">我要点赞</div>
              </div>
            </template>

            <div class="after_class_title">
              <span class="after_class_text">课后考考你</span>
              <span class="cylinder_border"></span>
            </div>
            <template v-if="questions.length > 0">
              <ul class="after_q_box">
                <li class="after_q" v-for="(item, index) in questions" :key="index">
                  <div class="q_t">
                    <img src="@/assets/icons/Q.png" alt="">
                    <span>{{item.title}}</span>
                  </div>
                  <div class="q_a">
                    <div v-for="(option, optionIndex) in item.questionOptions" :key="optionIndex">
                      <div class="q_a_item" :class="{active: item.active === option.id, correct: afterQFinish && option.isAnswer, error: afterQFinish && !option.isAnswer && item.active === option.id}" @click="questionSelect(index, optionIndex)">
                        <span class="option_type">{{afterQFinish && !option.isAnswer && item.active === option.id ? 'X' : questionOptionType[optionIndex]}}</span><span>{{option.title}}</span>
                      </div>
                      <br>
                    </div>
                  </div>
                  <!-- <div class="q_d" v-if="afterQFinish && item.detailDesc" @click="showAnswer(index)">
                    <span class="triangle_shape" :class="item.showAnswer ? 'active' : ''"></span>
                    <span>答案详解</span>
                  </div>
                  <div class="q_d_content" v-if="afterQFinish && item.detailDesc && item.showAnswer">{{item.detailDesc}}</div> -->
                </li>
              </ul>
              <div class="submit_answer_btn" :class="afterQFinish ? 'disabled' : ''" @click="submitAnswer">{{afterQFinish?'提交成功':'提交答案'}}</div>
            </template>
            <template v-else>
              <div class="empty_question">暂无问答</div>
            </template>
          </div>
        </van-tab>
        <van-tab title="选集">
          <div class="course-list">
            <ul class="courses">
              <li class="course" :class="[item.isUnlocked ? 'unlocked' : 'locked', item.learnStatus, subjectItem.id === item.id ? 'active' : '']" v-for="(item, index) in subject.subjectItems" :key="index" @click="switchVideo(item)">{{ item.title }}</li>
            </ul>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <Subscribe :isSubscribe="userInfo.subscribe" />
  </div>
</template>
<script>
import { getSubjectWithItems, updateSubjectItemLearned, getQuestions, answerQuestion, voteSubjectItem } from './query.gql'
import Subscribe from '@/components/Subscribe'
import VideoPlayer from '@/components/VideoPlayer'

export default {
  name: 'courseDetail',
  data() {
    return {
      active: 0,
      questions: [],
      questionOptionType: ['A', 'B', 'C', 'D'],
      afterQFinish: false,
      subject: {}, // 课程详情
      subjectItem: {}, // 课时详情
      userInfo: {}, // 用户信息
      hack: false
    }
  },
  async mounted() {
    const self = this
    await self.weixinAuth()
    const { sid, id } = self.$route.query
    console.log('进入页面的参数', sid, id)
    if (sid && id) {
      self.subjectItem.id = parseInt(id)
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.loadSubjectInfo(parseInt(sid)).then(res => {
        self.userInfo = res.data.profile
        // 设置视频是否兼容播放
        self.hack = self.userInfo.compatible
        console.log('正在学习课程内容', res)
        self.subject = self.$clone(res.data.subject)
        const subjectItem = res.data.subject.subjectItems.find(si => si.id === self.subjectItem.id)
        console.log('当前播放课程内容', subjectItem)
        self.subjectItem = self.$clone(subjectItem)

        let num = Math.floor(Math.random() * 11) + 10
        self.wechatShare({
          title: `${num}人正在拼→${self.subject.shareTitle}`,
          imgUrl: self.subject.smallLogoImg,
          desc: self.subject.shareContent,
          link: `${window.location.origin}/#/subject?id=${self.subject.id}`
        })
        self.getQuestions(self.subjectItem.id)
        self.$toast.clear()
        // self.$zhuge.identify(self.userInfo.id, {
        //   name: self.userInfo.nickname,
        //   avatar: self.userInfo.avatar
        // })
      }).catch(err => {
        self.$toast.clear()
        console.error('page: classroom/courseDetail。请求getSubjectWithItems报错', err)
      })
    } else {
      console.error('page: classroom/courseDetail。进入页sid和id面参数不全或无参数')
    }
  },
  methods: {
    playVideo() {
      // console.log('正在播放视频内容', this.subjectItem)
      this.updateSubjectItemStatus()

      // self.$zhuge.track('播放视频', {
      //   '课程名称': self.subject.title,
      //   '课时名称': self.subjectItem.title
      // })
    },
    switchVideo(subjectItem) {
      const self = this
      // console.log('观看课程 %O 切换到 %s', self.subjectItem, subjectItem)
      if (self.subjectItem.id !== subjectItem.id) {
        if (subjectItem.isUnlocked) {
          self.subjectItem = subjectItem
          self.getQuestions(self.subjectItem.id)
        } else {
          self.$toast.fail('课程尚未解锁')
          // console.log('未解锁啥都不干')
        }
      }
    },
    updateSubjectItemStatus() {
      const self = this
      // console.log('start updateSubjectItemStatus...')
      self.$apollo.mutate({
        mutation: updateSubjectItemLearned,
        variables: {
          id: self.subjectItem.id
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        // console.log('课程章节已更新', res)
        self.subjectItem.learnStatus = res.data.updateUserSubjectItem.userSubjectItem.status
        self.updateSubjectItems()
      }).catch(err => {
        console.error('page: classroom/courseDetail。请求updateSubjectItemLearned报错', err)
      })
    },
    updateSubjectItems() {
      this.subject.subjectItems.forEach((item, index) => {
        if (item.id === this.subjectItem.id) {
          this.subject.subjectItems.splice(index, 1, this.subjectItem)
        }
      })
    },
    loadSubjectInfo(id) {
      const self = this
      return self.$apollo.query({
        query: getSubjectWithItems,
        variables: { id: id, ignoreStatus: true },
        fetchPolicy: 'no-cache'
      })
    },
    getQuestions(subjectItemId) {
      const self = this
      self.$apollo.query({
        query: getQuestions,
        variables: { subjectItemId },
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.questions = res.data.questions
        self.questions.forEach(item => {
          item.active = ''
          item.showAnswer = false
        })
        self.afterQFinish = false
        // console.log(self.questions)
      }).catch(err => {
        console.error('page: classroom/courseDetail。请求getQuestions报错', err)
      })
    },
    submitAnswer() {
      if (this.afterQFinish) return
      let finish = true
      this.questions.forEach(item => {
        if (!item.active) {
          finish = false
        }
      })
      if (!finish) {
        this.$toast('你还未完成所有的题')
        return
      }
      this.afterQFinish = true
      let answers = []
      this.questions.forEach(item => {
        answers.push({
          question_id: item.id,
          question_option_id: item.active
        })
      })
      this.$apollo.mutate({
        mutation: answerQuestion,
        variables: {
          answers
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        console.log('提交问题答案', res)
      }).catch(err => {
        console.error('page: classroom/courseDetail。请求answerQuestion报错', err)
      })

      // const self = this
      // self.$zhuge.track('提交问答', {
      //   '课程名称': self.subject.title,
      //   '课时名称': self.subjectItem.title
      // })
    },
    questionSelect(index, optionIndex) {
      if (this.afterQFinish) return
      let questions = this.questions
      questions[index].active = questions[index].questionOptions[optionIndex].id
      this.questions.splice(index, 1, questions[index])
    },
    showAnswer(index) {
      let item = this.questions[index]
      item.showAnswer = !item.showAnswer
      this.questions.splice(index, 1, item)
    },
    voteSubjectItem() {
      let vote = {
        subjectItemId: this.subjectItem.id
      }

      this.$apollo.mutate({
        mutation: voteSubjectItem,
        variables: vote,
        fetchPolicy: 'no-cache'
      }).then(res => {
        if (res.data.voteSubjectItem.userSubjectItem != null) {
          this.subjectItem.vote += 1
          this.$toast.success('点赞成功')
        } else {
          this.$toast.fail(res.data.voteSubjectItem.error)
        }
        console.log('voteSubjectItem success', res)
      }).catch(err => {
        console.error('voteSubjectItem error', err)
      })
    }
  },
  components: {
    Subscribe,
    VideoPlayer
  }
}
</script>
<style lang="scss" scoped>
.course-detail-box {
  // margin-bottom: 66px;
  .subject-box {
    min-height: 100vh;
    background: url('~@/assets/images/sectionContantBg.png') no-repeat center;
    background-size: cover;
    padding-bottom: 15px;
    .user-info {
      padding: 10px;
      background: #fff;
      display: flex;
      .user-avatar {
        margin-right: 11px;
        img {
          width: 30px;
          height: 30px;
          border-radius: 15px;
        }
      }
      // .user-score {
      //   display: flex;
      //   align-items: center;
      //   img{
      //     width: 17px;
      //     height: 17px;
      //     margin-right: 6px;
      //   }
      //   span{
      //     color: #ff5e00;
      //     font-weight: bold;
      //     font-size: 17px;
      //   }
      // }
      .subject-info {
        flex: 1;
        line-height: 30px;
        width: 20px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .afterClass {
      margin: 50px 25px 25px;
      background: url('~@/assets/images/afterClassBg.png') no-repeat center;
      background-size: cover;
      border-radius: 7px;
      box-shadow: 0px 2px 8px 3px #e6af0b;
      position: relative;
      padding: 0 7px 32px 7px;
      .clip_img_box{
        width: 75px;
        height: 30px;
        position: absolute;
        top: -23px;
        left: 50%;
        transform: translate(-50%);
        img{
          width: 100%;
        }
      }
      .after_class_title{
        font-size: 20px;
        line-height: 50px;
        font-weight: bold;
        text-align: center;
        position: relative;
        .after_class_text{
          position: relative;
          z-index: 1;
          b{
            color: #ff8a01;
          }
        }
        .cylinder_border{
          width: 114px;
          height: 6px;
          background-color: #ffd101;
          border-radius: 10px;
          position: absolute;
          bottom: 20%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
      }
      .after_q_box{
        .after_q{
          border: 2px dashed #9c8acf;
          border-radius: 25px;
          padding: 16px 7px;
          box-shadow: 0px 4px 1px 1px #dfdaec;
          background-color: #fff;
          margin-bottom: 27px;
          overflow: hidden;
          .q_t{
            margin-bottom: 13px;
            font-size: 16px;
            color: #333;
            display: flex;
            line-height: 24px;
            img{
              width: 22px;
              height: 22px;
              margin-right: 5px;
            }
          }
          .q_a{
            .q_a_item{
              display: inline-block;
              font-size: 13px;
              line-height: 25px;
              color: #ff5b01;
              padding: 5px 10px;
              margin-bottom: 5px;
              .option_type{
                display: inline-block;
                width: 16px;
                height: 16px;
                line-height: 16px;
                color: #ffa53c;
                border: 2px solid #ffa53c;
                border-radius: 50%;
                text-align: center;
                margin-top: 2.5px;
                margin-right: 5px;
              }
              &.active{
                background-color: #ffa53c;
                color: #fff;
                border-radius: 20px;
                .option_type{
                  color: #fff;
                }
              }
              &.correct{
                background-color: #8adf2e;
                border-radius: 15px;
                color: #fff;
                .option_type{
                  color: #fff;
                  border-color: #8adf2e;
                }
              }
              &.error{
                background-color: #f00;
                border-radius: 15px;
                color: #fff;
                .option_type{
                  color: #fff;
                  border-color: #f00;
                }
              }
            }
          }
          .q_d{
            font-size: 11px;
            color: #484848;
            padding-top: 6px;
            padding-right: 3px;
            text-align: right;
            .triangle_shape{
              display: inline-block;
              width: 0;
              height: 0;
              border-width: 5px 0 5px 5px;
              border-style: solid;
              border-color: transparent transparent transparent #333;
              transition: transform 0.2s ease-in;
              margin-right: 5px;
              &.active{
                transform: rotate(90deg);
              }
            }
          }
          .q_d_content{
            font-size: 11px;
            line-height: 15px;
            padding: 6px 7px 0 9px;
          }
        }
      }
      .submit_answer_btn{
        width: 172px;
        height: 40px;
        line-height: 40px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        background-color: #ff8a01;
        text-align: center;
        margin: auto;
        border-radius: 25px;
        box-shadow: 0px -4px 1px 1px #ff7801 inset, 0px 8px 1px -2px #f2dab0;
        &.disabled{
          background-color: #9e9d9d;
          box-shadow: 0px -4px 1px 1px #8c8787 inset, 0px 8px 1px -2px #cecdcd;
        }
      }

      .empty_question {
        text-align: center;
      }
    }

    .van-tab {
      font-size: 18px;
    }

    .course-list {
      padding: 15px;
      .courses {
        .course {
          width: 90vw;
          height: 20vw;
          margin: 1vw auto auto;
          line-height: 18vw;
          padding-left: 5vw;
          box-sizing: border-box;
          &.unlocked {
            background: url('~@/assets/images/course_list_unlock_bg.png') no-repeat;
            background-size: 100%;
            color: #895630;
          }
          &.locked {
            background: url('~@/assets/images/course_list_lock_bg.png') no-repeat;
            background-size: 100%;
            color: #fff;
          }
          &.learned {
            background: url('~@/assets/images/course_list_studied_bg.png') no-repeat;
            background-size: 100%;
          }
          &.active {
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .vote{
    margin-bottom: 18px;
  }
}
</style>
